import { Component, OnInit } from '@angular/core';
import { Modal } from 'node_modules/bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Message } from 'src/app/models/message';

import { UsersService } from '../../../../services/users.service';
import { PersonService } from '../../../../services/person.service';
import { UserRoleService } from '../../../../services/user-role.service';
import { UserTeamService } from '../../../../services/survey/user-team.service';
import { ActivatedRoute } from '@angular/router';
import { TokenStorageService } from '../../../../services/token-storage.service';

@Component({
  selector: 'app-users-survey-list',
  templateUrl: './users-survey-list.component.html',
  styleUrls: ['./users-survey-list.component.scss']
})
export class UsersSurveyListComponent implements OnInit {

  testModal: Modal | undefined;
  formUsr: FormGroup;
  user: any = null;
  edit: boolean = false;
  result: any;
  users: any;

  roles: any;

  msg: Message = null;


  constructor(
    private fb: FormBuilder,
    private usersService: UsersService,
    private personService: PersonService,
    private userRoleService: UserRoleService,
    private userTeamService: UserTeamService,
    private activedRoute: ActivatedRoute,
    private tokenStorageService: TokenStorageService
  ) {
    this.createForm();
    this.loadInfoALLUser();
  }

  ngOnInit() {
  }

  /* Cargar data de los usuarios para la tabla  */
  key = false
  key1 = 0
  idTG = {}
  loadInfoALLUser() {
    this.idTG['id'] = this.activedRoute.snapshot.params['id'];
    this.key = this.tokenStorageService.isAdminLogged();
    this.key1 = this.activedRoute.snapshot.params['id'];
    this.usersService.getUsersByIdTeam(this.idTG).subscribe(
      res => {
        this.result = res
        this.users = res['data'];
      },
      err => {
        this.msg = err;
      }
    );
  }

  /* crear el formulario para el modal */
  createForm() {
    this.formUsr = this.fb.group({
      id: [null],
      name: [],
      lastname: [],
      idrol: [null],
      idperson: [null],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      pass: [''],
      isActive: [],
      isAllowed: [],
    })
  }

  /* Metodo que segun sea el caso guarda o edita la informacion de un usuario */
  save() {
    if (this.formUsr.invalid) {
      return Object.values(this.formUsr.controls).forEach(
        control => {
          if (control instanceof FormGroup) {
            Object.values(control.controls).forEach(
              control => control.markAsTouched()
            );
          } else {
            control.markAsTouched();
          }
        });
    } else {
      this.edit ? this.update(this.formUsr.value.id, this.formUsr.value) : this.create(this.formUsr.value);
    }
  }

  /* Modelos de las entidades que conforman la informacion de un usuario */
  persona = { id: 0, name: '', lastname: '' };
  usuario = { idperson: 0, email: '', pass: '', isActive: false };
  usuario_rol = { userId: 0, roleId: 0, isActive: false };
  usuario_team = { iduser: 0, idteam: 0, isActive: false };

  /* Metodo para crear un usuario */
  create(user: any) {

    this.persona.name = user.name
    this.persona.lastname = user.lastname;

    this.personService.create(this.persona).subscribe(

      res => {
        this.usuario.idperson = res['data'].id;
        this.usuario.email = user.email;
        this.usuario.pass = user.pass;
        this.usersService.createUser(this.usuario).subscribe(
          res => {

            this.usuario_rol.userId = res['data'].id;
            this.usuario_rol.roleId = 8;//tipo rol encuestado
            this.usuario_rol.isActive = user.isActive;
            this.userRoleService.create(this.usuario_rol).subscribe(
              res => {
                const idGroupTeam = this.activedRoute.snapshot.params['id'];
                this.usuario_team.idteam = idGroupTeam;
                this.usuario_team.iduser = this.usuario_rol.userId;
                this.usuario_team.isActive = user.isActive;

                this.userTeamService.create(this.usuario_team).subscribe(
                  res => {
                    // alert(res['message']);                    
                    this.testModal.toggle();
                  },
                  err => {
                    console.error(err)
                  }
                )
              }, err => {
                console.error(err)
              }
            );

          },
          err => {
            console.error(err)
          }
        )
      },
      err => {
        console.error(err)
      }
    );
    this.loadInfoALLUser();
  }

  /* Metodo para actualizar informacion del usuario */
  update(id: string, user: any) {

    this.persona.id = user.idperson;
    this.persona.name = user.name;
    this.persona.lastname = user.lastname;

    this.personService.update(this.persona).subscribe(

      res => {
        this.usuario.email = user.email;
        this.usuario.pass = user.pass;
        this.usuario.isActive = user.isActive;
        this.usersService.updateUser(id, this.usuario).subscribe(

          res => {
            this.usuario_rol.roleId = 8;
            this.usuario_rol.userId = user.id;
            this.userRoleService.update(this.usuario_rol).subscribe(
              res => {
                this.testModal.toggle();
              }, err => {
                console.error(err)
              }
            );

          },
          err => {
            console.error(err)
          }
        )
      },
      err => {
        console.error(err)
      }
    );
    this.loadInfoALLUser();
  }

  /*   cargamos lo datos seleccionado para el modal */
  changeModel(id: number) {

    if (id > 0) {
      this.loadInfoToEdit(id)
      this.open();
    }
    if (id === 0) {
      this.limpiarCampos();
      this.open();
    }

  }

  /*   Metodo para abrir el modal */
  open() {
    this.testModal = new bootstrap.Modal(document.getElementById('testModal'), {
      keyboard: false
    });
    this.testModal.show();
  }

  campoNoValido(campo: string) {
    return this.formUsr.get(campo).invalid && this.formUsr.get(campo).touched;
  }

  loadData() {
    this.formUsr.reset(this.user);
  }

  limpiarCampos() {
    this.formUsr.reset();
  }

  //variables para el metodo csv to array
  csvContent: string;
  listUsers: Array<any> = [];
  properties: any = "";
  flag: boolean = false;
  //Metodo para convertir un archivo CSV a array
  onFileLoad(fileLoadedEvent) {

    const textFromFileLoaded = fileLoadedEvent.target.result;
    this.csvContent = textFromFileLoaded;

    //Bandera que indica el for para sacar cabeceras
    let flag = false;
    // Almacenamos la data sin cabecera
    let objarray: Array<any> = [];
    //Almacenamos la cabecera
    let prop: Array<any> = [];
    //Tama;o total del array
    let size: any = 1;
    //controlamos el tama;o del array de datos
    let h = 0
    for (const line of this.csvContent.split(/[\r\n]+/)) {
      // console.log("vuelta numero ", h, "size es : ", size);

      /* if (h < size) { */
      h = h + 1;
      if (flag) {

        let obj = {};
        //Segun line para adelante son datos
        for (let k = 0; k < size; k++) {
          //cargamos el objeto de datas
          obj[prop[k]] = line.split(';')[k]
          // console.log("data :", obj[prop[k]]);

        }
        objarray.push(obj);
      } else {
        //Primera line  se captura las cabeceras
        for (let k = 0; k < line.split(';').length; k++) {
          size = line.split(';').length;
          //Eliminando todos los espacios para hacerlos útiles.
          prop.push(line.split(';')[k].replace(/ /g, ''));
        }
        flag = true;
        /* } */
      }

    }

    this.listUsers = objarray;
    this.properties = [];


    this.properties = prop;
    console.log(this.properties);
    console.log(this.listUsers);
    this.flag = true;
    // console.log(this.csvContent);
  }

  //Filtramos el tipo de archivo cuidando que sea CSV
  onFileSelect(input: HTMLInputElement) {

    const files = input.files;
    var fileTypes = ['csv'];  //acceptable file types

    if (files && files.length) {
      var extension = input.files[0].name.split('.').pop().toLowerCase(),  //Extension del archivo de entrada
        isSuccess = fileTypes.indexOf(extension) > -1;  //la extension debe ser del tipo
      //console.log(isSuccess);
      //  console.log("Filename: " + files[0].name);
      // console.log("Type: " + files[0].type);
      //  console.log("Size: " + files[0].size + " bytes");
      if (isSuccess) {
        const fileToRead = files[0];
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          this.onFileLoad(e);
          this.cargarData();
        }

        fileReader.readAsText(fileToRead, "UTF-8");
        /* fileReader.onloadend = this.cargarData */
      } else {
        alert("Tipo de archivo invalido!; debe ser CSV. Refresque el navegador en intente nuevamente.");
      }


    }

  }

  //Metodo intermedio para cargar lainformacion del array del evento al array de envio de datos
  informacionData = []
  cargarData() {
    this.informacionData = this.listUsers
  }

  //Metodo para guardar la informacion del CSV en base de datos
  createByCSV() {

    for (let index = 0; index < this.informacionData.length - 1; index++) {
      /* console.log("data numero : ", index, " nombres : ", this.informacionData[index].nombre); */
      this.persona.name = this.informacionData[index].nombre
      this.persona.lastname = this.informacionData[index].apellidos;
      /* console.log("Usuario persona : ", index, " nombres : ", this.persona); */

      this.personService.create(this.persona).subscribe(
        res => {
          this.usuario.idperson = res['data'].id;
          this.usuario.email = this.informacionData[index].correo;
          this.usuario.pass = this.informacionData[index].pasword;
          /* console.log("Usuario numero : ", index, " nombres : ", this.usuario); */

          this.usersService.createUser(this.usuario).subscribe(
            res => {
              this.usuario_rol.userId = res['data'].id;
              this.usuario_rol.roleId = 8;//tipo rol encuestado
              this.usuario_rol.isActive = true;
              /*  console.log("Usuario rol numero : ", index, " nombres : ", this.usuario_rol); */

              this.userRoleService.create(this.usuario_rol).subscribe(
                res => {
                  const idGroupTeam = this.activedRoute.snapshot.params['id'];
                  this.usuario_team.idteam = idGroupTeam;
                  this.usuario_team.iduser = res['data'].userId;
                  this.usuario_team.isActive = true;
                  /* console.log("Usuario team numero : ", index, " nombres : ", this.usuario_team); */

                  this.userTeamService.create(this.usuario_team).subscribe(
                    res => {
                      if (index === this.informacionData.length - 1) {
                        alert("El archivo CSV fue cargado")
                      }
                    },
                    err => {
                      console.error(err)
                    }
                  )
                }, err => {
                  console.error(err)
                }
              );
            },
            err => {
              console.error(err)
            }
          )


        },
        err => {
          console.error(err)
        }
      );


    }



  }

  //metodo para cargar la info del usuario a ser editado
  userTemp = {}
  loadInfoToEdit(id: any) {

    this.usersService.getDataOnePerson(id)
      .subscribe(
        res => {
          //Recibimos el Json e importamos a la variable local user atravez de useTemp para cargar el formulario
          this.userTemp['id'] = res['data'].id;
          this.userTemp['email'] = res['data'].email;
          this.userTemp['isActive'] = res['data'].isActive;
          this.userTemp['idperson'] = res['data']['person'].id;
          this.userTemp['name'] = res['data']['person'].name;
          this.userTemp['lastname'] = res['data']['person'].lastname;
          this.userTemp['idrol'] = ((res['data'])['roles'])[0].id

          this.user = this.userTemp;
          this.loadData();
          this.edit = true;
        },
        err => {
          this.msg = err;
        }
      )


  }


  sendId = {}
  /* Metodo para quistar privilegio de administrador de survey-> */
  removeAdmin(id1: string, m1: string) {
    this.sendId['id'] = id1

    if (confirm('Esta seguro que desea quitar privilegio de adminitrar encuestas ' + m1)) {

      this.usersService.removeGrantedAdminSurvey(this.sendId)
        .subscribe(
          res => {
            this.loadInfoALLUser();
            console.log(res);
          },
          err => {
            console.error(err)
          }
        );
    }
  }
  /* Metodo para otorgar privilegio de administracion de survey -> */
  grantAdmin(id1: string, m1: string) {
    this.sendId['id'] = id1

    if (confirm('Esta seguro que desea otorgar privilegio de administar encuestas ' + m1)) {

      this.usersService.grantedGrantedAdminSurvey(this.sendId)
        .subscribe(
          res => {
            this.loadInfoALLUser();
            console.log(res);
          },
          err => {
            console.error(err)
          }
        );
    }
  }

  /* Metodo para quistar acceso a encuestados-> */
  removeRespondent(id1: string, m1: string) {
    this.sendId['id'] = id1

    if (confirm('Esta seguro que desea restringir el acceso del encuestado ' + m1)) {

      this.usersService.deleteUser(this.sendId)
        .subscribe(
          res => {
            this.loadInfoALLUser();
            console.log(res);
          },
          err => {
            console.error(err)
          }
        );
    }
  }
  /* Metodo para otorgar acceso a encuestados -> */
  grantRespondent(id1: string, m1: string) {
    this.sendId['id'] = id1

    if (confirm('Esta seguro que desea permitir el acceso del encuestado ' + m1)) {

      this.usersService.grantedUser(this.sendId)
        .subscribe(
          res => {
            this.loadInfoALLUser();
            console.log(res);
          },
          err => {
            console.error(err)
          }
        );
    }
  }

}

